module.exports = __webpack_public_path__ + "img/mob.f8001f7f.jpg";